import { DataActionTypes } from "../actions/actiontypes";

const intialState = {
  isLoggedIn: false,
  passwordVisible: false,
};

const authReducers = (state = intialState, action) => {
  switch (action.type) {
    case DataActionTypes.set_Password_Visibility: {
      return { ...state, passwordVisible: action.payload };
    }
    default:
      return state;
  }
};

export default authReducers;
